<template>
  <div>
    <SplitJobDayDisplay
      v-for="(item, index) in schedules"
      v-bind:key="index"
      :day_index="day_index"
      :schedule_index="index"
    />
  </div>
</template>

<script>
import SplitJobDayDisplay from "@/components/job/view/SplitJobDayDisplay.vue";
import { mapState } from "vuex";

export default {
  name: "CombinedJobDayDisplay",
  props: {
    day_index: {
      type: Number,
      required: true,
    },
  },
  data: () => ({}),
  computed: {
    ...mapState("schedule", ["schedules"]),
  },
  mounted() {},
  methods: {},
  components: {
    SplitJobDayDisplay,
  },
};
</script>
